import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useEntitesTable from "components/Patrimoine/useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddMeterDialog from "./AddMeterDialog.js";
import EditUserDialog from "./EditMeterDialog";
import UserService from "services/UserService";

import AdvancedSearchContext from "context/AdvancedSearchContext";

import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { default as MUIButton } from "@mui/material/Button";

import { site,compte } from "variables/patrimoine.js";

import { getSite,getAccountMeters } from "services/ConfigServices";

//import "react-table/react-table.css";

// @mui/icons-material
import Edit from "@mui/icons-material/Edit";

//import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const useStyles2 = makeStyles((theme) => ({
  root: {
    margin: "0 0 0 -8px",
    "& > *": {
      margin: '8px',
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  chip: {
    margin: '4px',
  },
}));

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const Meters = (props) => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { energy, parameters } = props;
  const {
    gridState,
    error,
    refetch,
    invalidate,
    handleClose,
    showall,
    setMeters,
  } = useEntitesTable(
    energy,
    parameters,
    <AddMeterDialog
      energy={energy}
      parameters={parameters}
      closeModal={() => handleClose()}
      refetch={() => refetch()}
      deleteCounter={() => handleDeleteCounterChange()}
    />,
    "Nouveau compteur",
    "Ajout d'un compteur",
    "Liste compteurs",
  );
  const [deleteCounter, setDeleteCounter] = useState(0);
  const [open, setOpen] = useState(false);
  const [prevMetersList, setPrevMetersList] = useState();
  const [editedMetersList, setEditedMetersList] = useState();
  const [editedGroupId, setEditedGroupId] = useState("");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;

  const [meternumber, setMeternumber] = useState("");
  const [divisionunit, setDivisionunit] = useState("");
  const [divisionvalue, setDivisionvalue] = useState("");
  const [datedistribution, setDatedistribution] = useState("");
  const [functioncode, setFunctioncode] = useState("");
  const [creditline, setCreditline] = useState("");


  const [accountid, setAccountid] = useState(0);
  const [accountMeters, setAccountMeters] = useState([]);

  const handleDeleteCounterChange = (e) => {
    setDeleteCounter((prevCounter) => prevCounter + 1);
  };

  const handleMeternumberChange = (event) => { setMeternumber(event.target.value); };
  const handleDivisionunitChange = (event) => { setDivisionunit(event.target.value); };
  const handleDivisionvalueChange = (event) => { setDivisionvalue(event.target.value); };
  const handleDatedistributionChange = (event) => { setDatedistribution(event.target.value); };
  const handleFunctioncodeChange = (event) => { setFunctioncode(event.target.value); };
  const handleCreditlineChange = (event) => { setCreditline(event.target.value); };

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  let dataUsers = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      name: site.energy[energy][parameters].meternumber,
      selector: row => row.meternumber,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].name,
      selector: row => row.meternumber,
      sortable: true,
      cell: (row) => accountMeters.find((x)=>x.id === row.meternumber)?.metername || ""
    },
    {
      name: site.energy[energy][parameters].divisionunit,
      selector: row => row.divisionunit,
      sortable: true,
      cell: (row) => (
        <>
          <div className="actions-right">{row.divisionunit === "percent" ? '%' : row.divisionunit === "sqrmtr" ? 'm²' : "Autre"}</div>
        </>
      ),
    },
    {
      name: site.energy[energy][parameters].divisionvalue,
      selector: row => new Intl.NumberFormat('fr-FR').format((row.divisionvalue).replace(',','.')),
      sortable: true,
    },
    {
      name: "Entité",
      selector: (row) => row.groupid,
      omit: !showall,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
      
    },
    realestateupdate ?
    {
      name: "Actions",
      sortable: true,
      width: "8rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              color={"success"}
              className={classes.actionButton}
              onClick={editMeter(row)}
            >
              <Edit className={classes.icon} />
            </Button>
            <CustomDeleteButton
              deleteTitle={"Suppression du compteur"}
              deleteSubTitle={
                "Êtes-vous sûr de vouloir supprimer le compteur ?"
              }
              handleSupprimer={deleteMeter(row)}
            />
          </div>
        </>
      ),
    } : {},
  ];

  const ExpandableComponent = props => {
    const { data, energy, parameters, dsoData, utilitiesData } = props;
    const [value, setValue] = useState(0);

    const accountmeterdata = accountMeters?.find((meter) => meter.id === data.meternumber);
    const classes = useStyles2();

    function handleSubMenuChange(value) {
      setValue(value);
    }

    const SubTabs = () => {
      return (
        <>
          {
            accountmeterdata ?
              <>
                {
                  energy === 'electricity' ?
                    <div>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].address} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.localization?.description}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].acheminement} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.acheminement}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].powersubscriptionhph} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.powersubscriptionhph}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].powersubscriptionhch} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.powersubscriptionhch}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].powersubscriptionhpe} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.powersubscriptionhpe}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].powersubscriptionhce} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.powersubscriptionhce}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].powersubscriptionpointe} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.powersubscriptionpointe}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].powersubscriptionmax} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.powersubscriptionmax}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].monthlyconsumption} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.monthlyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].dailyconsumption} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.dailyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].loadcurve} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.loadcurve === true ? 'Oui' : 'Non'}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].contractualdata} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.contractualdata === true ? 'Oui' : 'Non'}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].utilitydata} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.utilitydata === true ? 'Oui' : 'Non'}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].associatedfiles} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.associatedfiles}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].comments} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.comments}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].description} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.description}</ElementData>
                      </ExpandableElement>
                      <ExpandableElement>
                        <ElementTitle>{compte.energy[energy][parameters].usagecode} : </ElementTitle>
                        <ElementData>{accountmeterdata.details?.usagecode}</ElementData>
                      </ExpandableElement>
                    </div> : energy === 'gas' ?
                      <div>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].address} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.localization?.description}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].cja} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.cja}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].profil} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.profil}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].car} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.car}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].monthlyconsumption} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.monthlyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].dailyconsumption} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.dailyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].loadcurve} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.loadcurve === true ? 'Oui' : 'Non'}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].contractualdata} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.contractualdata === true ? 'Oui' : 'Non'}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].utilitydata} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.utilitydata === true ? 'Oui' : 'Non'}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].associatedfiles} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.associatedfiles}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].comments} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.comments}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].description} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.description}</ElementData>
                        </ExpandableElement>
                        <ExpandableElement>
                          <ElementTitle>{compte.energy[energy][parameters].usagecode} : </ElementTitle>
                          <ElementData>{accountmeterdata.details?.usagecode}</ElementData>
                        </ExpandableElement>
                      </div> : energy === 'water' ?
                        <div>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].address} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.address?.description}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].acheminement} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.acheminement}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].monthlyconsumption} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.monthlyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].dailyconsumption} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.dailyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].loadcurve} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.loadcurve === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].contractualdata} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.contractualdata === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].associatedfiles} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.associatedfiles}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].comments} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.comments}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].description} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.description}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].usagecode} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.usagecode}</ElementData>
                          </ExpandableElement>
                        </div> :
                        <div>

                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].address} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.localization?.description}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].monthlyconsumption} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.monthlyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].dailyconsumption} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.dailyconsumption === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].loadcurve} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.loadcurve === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].contractualdata} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.contractualdata === true ? 'Oui' : 'Non'}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].associatedfiles} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.associatedfiles}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].comments} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.comments}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].description} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.description}</ElementData>
                          </ExpandableElement>
                          <ExpandableElement>
                            <ElementTitle>{compte.energy[energy][parameters].usagecode} : </ElementTitle>
                            <ElementData>{accountmeterdata.details?.usagecode}</ElementData>
                          </ExpandableElement>
                        </div>
                }
              </> : <></>
          }
        </>
      );

    };

    return (
      <Container>
        <ExpandableContainer>
          <div>
            <SubTabs />
          </div>
        </ExpandableContainer>
      </Container>
    );
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "energy." + energy + "." + parameters),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevMetersList(res.data.detail?.energy?.[energy]?.[parameters] || []);
        setAccountid(res.data.detail?.account);
      });

  }, [deleteCounter]);


  useEffect(() => {
    if (accountid > 0) {
      axios
        .get(
          getAccountMeters(accountid, energy),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpMetersData = res.data.meters?.map((data) => {
            return (
              {name : data.meternumber, id: data.meternumber, metername: data.details?.name || '', details: data.details }
            );
          });
          setAccountMeters(tmpMetersData || []);
        });
    }
  }, [accountid]);


  const [idSelected, setIdSelected] = useState();

  const editMeter = (row) => async () => {
    let obj = dataUsers.find((o) => o.uuid === row.uuid);
    setIdSelected(obj.uuid);
    setMeternumber(obj.meternumber);
    setDivisionunit(obj.divisionunit || '');
    setDivisionvalue(obj.divisionvalue || '');
    setDatedistribution(obj.datedistribution || '');
    setFunctioncode(obj.functioncode || '');
    setCreditline(obj.creditline || '');
    if(obj.groupid && obj.groupid!=chartIdGroup)
    {
      axios
      .get(
        getSite(obj.groupid, "energy." + energy + "." + parameters),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setEditedMetersList(res.data.detail?.energy?.[energy]?.[parameters] || []);
        setEditedGroupId(obj.groupid);
        handleClickOpen();
      });
    }
    else
    {
      handleClickOpen();
      setEditedMetersList(prevMetersList);
      setEditedGroupId(chartIdGroup);
    }
    
  };

  const deleteMeter = (row) => async () => {
    let obj = dataUsers.find((o) => o.uuid === row.uuid);
    if(obj.groupid && obj.groupid!=chartIdGroup)
    {
      axios
      .get(
        getSite(obj.groupid, "energy." + energy + "." + parameters),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        deleteMeterFromGroup(obj.groupid,res.data.detail?.energy?.[energy]?.[parameters],obj);
      });
    }
    else
    {
      deleteMeterFromGroup(chartIdGroup,prevMetersList,obj);
    }
  };

  const deleteMeterFromGroup = (group,meterslist,obj) => {
    const indexToReplace = meterslist.findIndex((x) => x.uuid === obj.uuid);
    meterslist.splice(indexToReplace, 1);
    axios
      .put(
        getSite(group, "energy." + energy + "." + parameters),
        meterslist,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        refetch();
      })
      .catch(() => { });
  };
  
const handleSelectedRowsChange = (selection) => {
  setMeters(selection.selectedRows);
};

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          expandOnRowClicked
          expandableRows
          expandableRowsComponent={ExpandableComponent}
          expandableRowsComponentProps={{ energy, parameters }}
          onSelectedRowsChange={handleSelectedRowsChange}
          selectableRows={true}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleEditClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Modifier le compteur
          </DialogTitle>
          <DialogContent dividers>
            <EditUserDialog
              energy={energy}
              parameters={parameters}
              closeModal={handleEditClose}
              refetch={refetch}
              idSelected={idSelected}
              prevMetersList={prevMetersList}
              meternumber={meternumber}
              divisionunit={divisionunit}
              divisionvalue={divisionvalue}
              datedistribution={datedistribution}
              functioncode={functioncode}
              creditline={creditline}
              handleMeternumberChange={handleMeternumberChange}
              handleDivisionunitChange={handleDivisionunitChange}
              handleDivisionvalueChange={handleDivisionvalueChange}
              handleDatedistributionChange={handleDatedistributionChange}
              handleFunctioncodeChange={handleFunctioncodeChange}
              handleCreditlineChange={handleCreditlineChange}
              accountMeters={accountMeters}
              editedGroupId={editedGroupId}
              editedMetersList={editedMetersList}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Meters;
